import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import { PANEL_STATES } from "../../state/reducers/projectWizard/projectWizardConstants.js";
import { ROW_STATE } from "../forms/formConstants.js";

export function sshTableValidationSchema(messages) {
  return Yup.lazy(value => {
    if (value === PANEL_STATES.SKIPPED) {
      return Yup.mixed();
    }
    return Yup.array()
      .of(
        Yup.object().shape({
          state: Yup.string(),
          "@id": Yup.string().when("state", {
            is: ROW_STATE.APPLY_EXISTING,
            then: Schemas.simpleStringSchema("@id", messages, true)
          }),
          name: Yup.string().when("state", {
            is: ROW_STATE.NEW,
            then: Schemas.simpleStringSchema("Name", messages, true)
          }),
          value: Yup.string().when("state", {
            is: ROW_STATE.NEW,
            then: Schemas.sshPubliclKeySchema("Public Key", messages, true)
          })
        })
      )
      .required();
  });
}
